module.exports = __webpack_public_path__ + "static/media/16-fernando-antonio.cf50ee4b.webp";